import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
const formFieldContext = __WEBPACK_EXTERNAL_MODULE_react__.createContext({});
const formItemContext = __WEBPACK_EXTERNAL_MODULE_react__.createContext({});
export { formFieldContext, formItemContext };

//# sourceMappingURL=context.js.map